<script>
  import { surveyStore } from '../../stores/surveyStore.js';
  
  export let emailCaptureType = 'transactional';
  
  $: isTransactional = emailCaptureType === 'transactional';
  $: heading = isTransactional ? 'Results sent.' : "You're on the list.";
  $: message = isTransactional
    ? 'Check your inbox for your membership match and everything that comes with it.'
    : "We'll keep you posted on team news and availability before it goes public.";
  
  function handleBackToResult() {
    surveyStore.goToScreen('result', 5);
  }
</script>

<div class="card">
  <div class="success-icon">✓</div>
  <h2 class="card-title" style="font-size:1.5rem">{heading}</h2>
  <div class="card-body">
    <p>{message}</p>
  </div>
  <div class="divider"></div>
  <button class="cta-primary" on:click={handleBackToResult}>
    Back to my membership match
  </button>
</div>
